import "../scss/main.scss";

(function ($) {
  $(document).ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.headerFunctions();
      this.animations();
    },

    headerFunctions: function () {
      $("header .navbar .menu > li.menu-item-has-children > a").click(function (e) {
        if ($(window).width() > 768) {
          e.preventDefault();
        } else {
          $(this).parent().find('ul.sub-menu').toggleClass('visible');
        }
      });

      $(".toggle-nav").click(function (e) {
        $(".navbar .main-menu-container").fadeToggle();
        $(".icon-bar").toggleClass("toggled");
        e.preventDefault();
      });
    },

    animations: function () {
      function isInViewport(node) {
        var rect = node.getBoundingClientRect();
        return (
          (rect.height > 0 || rect.width > 0) &&
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }

      $(window).scroll(function () {
        $("#about, #products .product, .animated").each(
          function () {
            if (isInViewport(this)) {
              $(this).addClass("inViewport");
            }
          }
        );
      });
    },
  };
})(jQuery);
